import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, List, ListItem, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

const InstallationServicesText = css`
  margin-bottom: 8px;
`;

const InstallationServicesList = css`
  && {
    li:not(:last-child) {
      margin-bottom: 4px;
    }
  }
`;

type InstallationServicesProps = {
  onConsultationSignupBtnClick: () => void;
};

export const InstallationServices = ({ onConsultationSignupBtnClick }: InstallationServicesProps) => (
  <>
    <ModalHeader title="Услуги по&nbsp;установке" />
    <ModalContent>
      <Typography className={InstallationServicesText} variant="m" size="body_long">
        Мы&nbsp;работаем только с&nbsp;высокопрофильными мастерами от&nbsp;наших партнёров, которые выполнят
        все необходимые работы для качественной установки:
      </Typography>
      <List listStyle="disc" className={InstallationServicesList}>
        <ListItem>
          <Typography variant="m" size="body_long">
            замер проёма (вернём деньги за&nbsp;замер&nbsp;&mdash; просто закажите у&nbsp;нас дверь
            и&nbsp;установку);
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long">
            демонтаж старой двери;
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long">
            сужение или расширение проёма;
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long">
            оформление проёма;
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long">
            доставка и&nbsp;установка двери день в&nbsp;день.
          </Typography>
        </ListItem>
      </List>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementName="Услуги по установке"
        elementText="Оставить заявку"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
